import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "as"],
    _excluded2 = ["className", "id", "children", "distance", "appendTo", "hasArrow", "hasLine", "width", "variant", "trigger", "isPadded", "isCloseOnBlur", "isInteractive", "isVisible", "placement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Children, cloneElement, forwardRef, createContext, useContext, useRef } from 'react';
import cx from 'classnames';
import { prefix } from '../../tools';
import { StyledPopover, StyledPopoverTrigger, StyledPopoverContent } from './Popover.styles';
import { jsx as _jsx } from "react/jsx-runtime";
var PopoverContext = createContext();

var usePopoverContext = function usePopoverContext() {
  var context = useContext(PopoverContext);

  if (context == null) {
    throw Error('usePopoverContext must be used within <Popover/>');
  }

  return context;
};

var PopoverTrigger = forwardRef(function (_ref, ref) {
  var children = _ref.children,
      as = _ref.as,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsx(StyledPopoverTrigger, {
    ref: ref,
    children: children
  });
});

var PopoverContent = function PopoverContent(_ref2) {
  var children = _ref2.children;

  var _usePopoverContext = usePopoverContext(),
      width = _usePopoverContext.width,
      isPadded = _usePopoverContext.isPadded;

  return _jsx(StyledPopoverContent, {
    width: width,
    padded: isPadded,
    children: children
  });
};

var Popover = forwardRef(function (_ref3, ref) {
  var _cx;

  var customClassName = _ref3.className,
      id = _ref3.id,
      children = _ref3.children,
      _ref3$distance = _ref3.distance,
      distance = _ref3$distance === void 0 ? 0 : _ref3$distance,
      _ref3$appendTo = _ref3.appendTo,
      appendTo = _ref3$appendTo === void 0 ? document.body : _ref3$appendTo,
      _ref3$hasArrow = _ref3.hasArrow,
      hasArrow = _ref3$hasArrow === void 0 ? true : _ref3$hasArrow,
      _ref3$hasLine = _ref3.hasLine,
      hasLine = _ref3$hasLine === void 0 ? true : _ref3$hasLine,
      _ref3$width = _ref3.width,
      width = _ref3$width === void 0 ? null : _ref3$width,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? 'default' : _ref3$variant,
      _ref3$trigger = _ref3.trigger,
      trigger = _ref3$trigger === void 0 ? 'click focus' : _ref3$trigger,
      _ref3$isPadded = _ref3.isPadded,
      isPadded = _ref3$isPadded === void 0 ? true : _ref3$isPadded,
      _ref3$isCloseOnBlur = _ref3.isCloseOnBlur,
      isCloseOnBlur = _ref3$isCloseOnBlur === void 0 ? true : _ref3$isCloseOnBlur,
      _ref3$isInteractive = _ref3.isInteractive,
      isInteractive = _ref3$isInteractive === void 0 ? true : _ref3$isInteractive,
      isVisible = _ref3.isVisible,
      _ref3$placement = _ref3.placement,
      placement = _ref3$placement === void 0 ? 'auto' : _ref3$placement,
      rest = _objectWithoutProperties(_ref3, _excluded2);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-popover"), true), _defineProperty(_cx, "".concat(prefix, "-popover--tooltip"), variant === 'tooltip'), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  var triggerRef = useRef();
  var instanceRef = useRef();
  var context = {
    triggerRef: triggerRef,
    instanceRef: instanceRef,
    isCloseOnBlur: isCloseOnBlur,
    isPadded: isPadded,
    isVisible: isVisible,
    width: width
  };
  var renderTrigger;
  var renderContent;
  Children.map(children, function (el, index) {
    if (index === 1) {
      renderContent = el;
    }

    if (index === 0) {
      renderTrigger = cloneElement(el, {
        ref: triggerRef
      });
    }
  });
  return _jsx(PopoverContext.Provider, {
    value: context,
    children: _jsx(StyledPopover, _objectSpread(_objectSpread({
      trigger: trigger === 'manual' ? undefined : trigger,
      hideOnClick: trigger === 'manual' ? undefined : isCloseOnBlur,
      className: className,
      placement: placement,
      content: renderContent,
      duration: 150,
      arrow: hasArrow,
      interactive: isInteractive,
      role: "dialog",
      maxWidth: width,
      appendTo: appendTo,
      animation: "shift-away",
      ignoreAttributes: true,
      onCreate: function onCreate(instance) {
        return instanceRef.current = instance;
      },
      visible: isVisible
    }, rest), {}, {
      children: renderTrigger
    }))
  });
});
Popover.Trigger = PopoverTrigger;
Popover.Content = PopoverContent;
export default Popover;